module.exports = vendor_615572c2a385c38b9c3d;


//////////////////
// WEBPACK FOOTER
// external "vendor_615572c2a385c38b9c3d"
// module id = 7
// module chunks = 8